import RefreshIcon from "@mui/icons-material/Refresh";
import { Alert, Box, CircularProgress, IconButton, LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEntityManagementUnits } from "../../../hooks/Entity";
import ManagementUnitsTable from "../../ManagementUnits/ManagementUnitsTable";
import { useEffect } from "react";

interface ManagementUnitsTabProps {
  entityId?: string;
  entityName?: string;
  handleError?: any;
}

const ManagementUnitsTab: React.FC<ManagementUnitsTabProps> = ({
  entityId,
  entityName,
  handleError
}) => {
  const { t } = useTranslation();
  const {
    managementUnitsData,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    create,
    update,
    remove,
  } = useEntityManagementUnits(entityId);
  
    useEffect(() => {
      if (!handleError) return;
      if (isError) handleError(error);
    }, [isError]);

  if (isPending && !managementUnitsData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError && !managementUnitsData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Alert
          severity="error"
          action={
            <IconButton onClick={() => refetch()} size="small">
              <RefreshIcon />
            </IconButton>
          }
        >
          {t("generic.errors.something-went-wrong")}
        </Alert>
      </Box>
    );
  }

  if (!managementUnitsData) return null;

  return (
    <Box sx={{ position: "relative" }}>
      {isFetching && (
        <LinearProgress
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            height: 2,
          }}
        />
      )}

      <ManagementUnitsTable
        entityId={Number(entityId)}
        entityName={entityName ?? ""}
        tableData={managementUnitsData ?? []}
        onCreate={async (values) => {
          await create(values);
        }}
        onUpdate={async (id, values) => {
          await update({ managementUnitId: id, values });
        }}
        onDelete={async (id) => {
          await remove(id);
        }}
      />
    </Box>
  );
};

export default ManagementUnitsTab;
